'use client';

import {motion} from 'motion/react';
import {ReactNode} from 'react';

import styles from './accordion.module.scss';

interface AccordionTabProps {
    title: string;
    expanded: boolean;
    onClick: () => void;
    children: ReactNode;
}

export function AccordionTab({title, expanded, onClick, children}: AccordionTabProps) {
    return (
        <motion.div
            className={`${styles.tab} ${expanded ? styles.expanded : ''}`}
            initial={false}
            animate={{
                maxWidth: expanded ? '100%' : '10%',
            }}
            transition={{
                duration: 0.4,
                ease: 'easeInOut',
            }}
            onClick={onClick}
        >
            <div className={styles.tabContent}>
                <motion.h3 className={styles.title}>
                    <motion.span
                        className={styles.titleSpan}
                        animate={{
                            transform: expanded ? 'rotate(0deg)' : 'rotate(90deg)',
                        }}
                    >
                        {title}
                    </motion.span>
                </motion.h3>
                <motion.div
                    className={styles.content}
                    initial={false}
                    animate={{
                        opacity: expanded ? 1 : 0,
                    }}
                    transition={{
                        duration: expanded ? 0.3 : 0,
                        delay: expanded ? 0.4 : 0,
                    }}
                >
                    <span className={styles.contentText}>{children}</span>
                </motion.div>
            </div>
            {!expanded && (
                <div className={styles.tabHeader}>
                    <motion.div
                        className={styles.tabHeaderIcon}
                        animate={{
                            opacity: expanded ? 0 : 1,
                        }}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                        >
                            <path
                                d="M9.96484 0.929688V19.9997"
                                stroke="#1A1A1A"
                                strokeWidth="1.85311"
                            />
                            <path
                                d="M19.4961 10.4653L0.426088 10.4653"
                                stroke="#1A1A1A"
                                strokeWidth="1.85311"
                            />
                        </svg>
                    </motion.div>
                </div>
            )}
        </motion.div>
    );
}
